import { BoxProps } from '@chakra-ui/react'
import { useMe } from '@hb/react'
import { FieldTypes, Note, UpdateCallback } from '@hb/shared'
import React, { useCallback, useMemo } from 'react'
import { useAppGroup } from '../../hooks/backend/user/useAppGroup'
import { SimpleForm } from './FinalForm/SimpleForm'

export const NoteForm: React.FC<{
  note?: Note | null
  placeholder?: string
  onSubmit: (data: Note) => Promise<UpdateCallback>
  boxProps?: BoxProps
  placeholderAbove?: boolean
}> = ({ note, boxProps, onSubmit, placeholder = 'Note...', placeholderAbove = true }) => {
  const id = useMe()?.uid

  const group = useAppGroup()
  const submit = useCallback(
    async (data: string): Promise<UpdateCallback> => {
      if (id) {
        return onSubmit({
          text: data ?? '',
          updatedOn: Date.now(),
          updatedByGroup: group,
          updatedBy: id,
        })
      }
      return { error: 'Error - not authenticated' }
    },
    [id, onSubmit, group],
  )
  const initValue = useMemo(
    () => ({
      value: note?.text ?? '',
      updatedOn: note?.updatedOn,
      updatedBy: note?.updatedBy,
      updatedByGroup: note?.updatedByGroup,
    }),
    [note],
  )
  return (
    <SimpleForm
      boxProps={{ width: '100%', ...boxProps }}
      field={{ type: FieldTypes.TEXTAREA, placeholder, optional: true }}
      onSubmit={submit}
      placeholderAbove={placeholderAbove}
      theme="detailed"
      value={initValue}
    />
  )
}
